import type { ResolvedFeaturePageEntity } from "@garimpa/api/featurePages/types";

import type { FeaturePageAlbumEntity } from "./feature-page-album-entity";

export function isFeaturePageAlbumEntity(
  entity: ResolvedFeaturePageEntity,
): entity is FeaturePageAlbumEntity {
  return entity.entityType === "work" || entity.entityType === "release";
}
